module.exports = __webpack_public_path__ + "static/thumbnail-nfi-graph-0d13d59772d349fad08fdd22ec30b47d.png";